/** Tipos del módulo de encuestas (consumo legacy + admin Fase 1). */
export const SURVEY_QUESTION_TEXT_SHORT = "TEXT_SHORT";
export const isSurveyInboxActionablePending = (item) => item.recipientStatus === "PENDING" && item.courseAlreadyResponded !== true;
export const surveyReportProgress = (survey) => {
    const responses = Number(survey.responseCount || 0);
    const unitCount = Number(survey.responseUnitCount || 0);
    const countsCourses = survey.responseUnit === "COURSE" && unitCount > 0;
    const total = countsCourses
        ? unitCount
        : Number(survey.recipientCount || 0);
    const pending = Math.max(0, total - responses);
    const pct = total > 0 ? Math.round((responses / total) * 100) : 0;
    return { responses, total, pending, pct, countsCourses };
};
export const SURVEY_COURSE_ALREADY_RESPONDED = "SURVEY_COURSE_ALREADY_RESPONDED";
export const isSurveyCourseAlreadyRespondedError = (error) => {
    const e = error;
    const code = e?.response?.data?.error?.code || e?.response?.data?.code || e?.code;
    if (code === SURVEY_COURSE_ALREADY_RESPONDED)
        return true;
    const message = String(e?.response?.data?.error?.message ||
        e?.response?.data?.message ||
        e?.message ||
        "");
    return message.includes("integrante de tu curso");
};
export const QUESTION_TYPE_LABELS = {
    TEXT_SHORT: "Texto corto",
    TEXT_LONG: "Texto largo",
    MULTIPLE_CHOICE_SINGLE: "Opción única",
    MULTIPLE_CHOICE_MULTI: "Opción múltiple",
    BOOLEAN: "Sí / No",
    NUMBER: "Número",
    RANKING: "Ordenar preferencias",
};
export const SURVEY_STATUS_LABELS = {
    DRAFT: "Borrador",
    PUBLISHING: "Publicando",
    PUBLISHED: "Publicada",
    CLOSED: "Cerrada",
    ARCHIVED: "Archivada",
    EXPIRED: "Expirada",
    DELETED: "Eliminada",
};
